import subDays from 'date-fns/subDays';
import subMonths from 'date-fns/subMonths';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';

export const MILLISECONDS_IN_SECOND = 1000;
export const MINUTE_IN_SECONDS = 60;
export const HOUR_IN_SECONDS = 60 * MINUTE_IN_SECONDS;
export const DAY_IN_SECONDS = 24 * HOUR_IN_SECONDS;
export const WEEK_IN_SECONDS = 7 * DAY_IN_SECONDS;
export const MONTH_IN_SECONDS = 30 * DAY_IN_SECONDS;
export const YEAR_IN_SECONDS = 365 * DAY_IN_SECONDS;

export const timestamp = (date = false) => {
	date = date ? new Date(date).getTime() : Date.now();
	return Math.round(date / MILLISECONDS_IN_SECOND);
};

export const getDaysStartEnd = (days, from = 'today') => {
	const start = subDays(Date.now(), days);
	start.setHours(0, 0, 0, 0);

	const end = 'today' === from ? new Date() : from;
	end.setHours(0, 0, 0, 0);

	return { start, end };
};

export const yesterday = () => {
	const yesterday = subDays(new Date(), 1);
	yesterday.setHours(0, 0, 0, 0);

	return yesterday;
};

export const lastWeek = () => {
	const lastWeek = subDays(new Date(), 7);

	return {
		start: startOfWeek(lastWeek),
		end: endOfWeek(lastWeek),
	};
};

export const thisMonth = (endsNow = true) => {
	const today = new Date();

	return {
		start: startOfMonth(today),
		end: endsNow ? today : endOfMonth(today),
	};
};

export const lastMonth = () => {
	const lastMonth = subMonths(new Date(), 1);

	return {
		start: startOfMonth(lastMonth),
		end: endOfMonth(lastMonth),
	};
};

export const lastMonths = (numberMonths) => {
	const end = endOfMonth(subMonths(new Date(), 1));

	return {
		start: startOfMonth(subMonths(end, numberMonths - 1)),
		end,
	};
};
